import './Navbar.css'
import {endpoint} from '../../utils/endpoint'
import React, { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { RiMenuLine, RiCloseLine } from 'react-icons/ri'
import { FaArrowAltCircleUp } from 'react-icons/fa'
import { NavItems } from './NavItems'
import { useEffect } from 'react/';
import { useNavigate } from 'react-router-dom'
import ThemeContext from '../../contexts/ThemeContext';
import ThemeSwitcher from '../ThemeSwitcher/ThemeSwitcher';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';


const Navbar = ({ language, txtAlign, cur }) => {

    const { menu } = language;
    let [toggleMenu, setToggleMenu] = useState(false);
    const [toggleScrUp, setToggleScrUp] = useState(false);
    const { theme } = useContext(ThemeContext);
    const navigate = useNavigate();
    const logo = theme.mode === 'light' ? 'logo-light.svg' : 'logo-dark.svg'

    useEffect(() => {
        const onScroll = () => {
            setToggleMenu(false);
            setToggleScrUp(window.scrollY > 400);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const scrollToTop = (e) => {
        e.preventDefault();
        const el = document.getElementById(menu[0][1]);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <>
        <header dir="ltr" className={`Navbar Navbar--glass Navbar--${theme.mode}`}>
            <div className="Navbar-inner">
                <div className="Navbar-start">
                    <div
                        className="logo-wrapper"
                        onClick={() => navigate('/')}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && navigate('/')}
                    >
                        <img
                            src={`${endpoint}${logo}`}
                            alt="QB Media"
                            className="logo"
                        />
                    </div>
                    <ThemeSwitcher />
                </div>

                <div className="Navbar-end">
                    <LanguageSwitcher cur={cur} />
                    <div className="links">
                        <NavItems menu={menu} txtAlign={txtAlign} />
                    </div>
                    <div className="mobile-nav">
                    {!toggleMenu ? (
                        <RiMenuLine
                            size={30}
                            color={theme.text}
                            onClick={() => setToggleMenu(true)}
                        />
                    ) : (
                        <RiCloseLine
                            size={30}
                            color={theme.text}
                            onClick={() => setToggleMenu(false)}
                        />
                    )}

                    <div
                        className={`mobile-links ${toggleMenu ? 'fade-in-top' : 'fade-in-bottom'}`}
                    >
                        <NavItems menu={menu} />
                    </div>
                    </div>
                </div>
            </div>
        </header>
        {toggleScrUp &&
            createPortal(
                <a
                    className="scroll-up scroll-up--visible"
                    href={`#${menu[0][1]}`}
                    onClick={scrollToTop}
                    aria-label="Scroll to top"
                >
                    <FaArrowAltCircleUp size={40} />
                </a>,
                document.body
            )}
        </>
    )
}

export default Navbar